// ✅ src/components/ImportanceDropdown.jsx
import { useState, useEffect } from "react";
import { MenuItem, FormControl, Select, InputLabel } from "@mui/material";

// ✅ Centralized base URL with fallback
const BASE_URL = process.env.REACT_APP_BASE_URL ?? "";

/**
 * Dropdown for selecting ticket importance.
 * Props:
 * - ticketId: the ID of the ticket (required for server update)
 * - currentImportance: current importance level ("high" | "medium" | "low")
 * - onChange: optional callback when importance changes
 */
const ImportanceDropdown = ({ ticketId, currentImportance = "medium", onChange }) => {
  const [importance, setImportance] = useState(currentImportance);

  useEffect(() => {
    setImportance(currentImportance);
  }, [currentImportance]);

  const handleChange = async (event) => {
    const selected = event.target.value;
    setImportance(selected);
    onChange && onChange(selected);

    try {
      const response = await fetch(`${BASE_URL}/api/tickets/${ticketId}/importance`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ importance: selected }),
      });

      if (!response.ok) {
        throw new Error("Failed to update importance.");
      }
    } catch (error) {
      console.error("Error updating importance:", error.message);
    }
  };

  if (!ticketId) return null;

  return (
    <FormControl fullWidth size="small">
      <InputLabel>Importance</InputLabel>
      <Select value={importance} label="Importance" onChange={handleChange}>
        <MenuItem value="high">High</MenuItem>
        <MenuItem value="medium">Medium</MenuItem>
        <MenuItem value="low">Low</MenuItem>
      </Select>
    </FormControl>
  );
};

export default ImportanceDropdown;